<template>
  <div class="twitter-analytics-public-chart-follower">
    <div class="message message-info" v-if="isEmpty">データがありません。</div>
    <div class="div" v-else>
      <div class="mb-x2" layout layout-align="end-center">
        <el-tooltip placement="top" content="CSVダウンロード">
          <CsvDownload :download="downloadCsv" text=""></CsvDownload>
        </el-tooltip>
      </div>
      <AnalyticsChartDoughnut
        :data="followerAnalytics"
        :chartStyles="chartStyles"
        :height="450"
      ></AnalyticsChartDoughnut>
    </div>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import AnalyticsChartDoughnut from '@/client/components/_atoms/analytics_chart_doughnut'
import CsvDownload from '@/client/components/_atoms/csv_download'
import { useTwitterAnalyticsPublicStore } from '@/client/store/useTwitterAnalyticsPublicStore'

export default defineComponent({
  components: {
    CsvDownload,
    AnalyticsChartDoughnut
  },
  data() {
    return {
      chartStyles: {
        margin: '0 auto'
      }
    }
  },
  computed: {
    ...mapState(useTwitterAnalyticsPublicStore, {
      followerAnalytics: state => state.followerAnalytics,
      campaign: state => state.campaign
    }),
    isEmpty() {
      return this.followerAnalytics.every(follower => follower.count === 0)
    }
  },
  methods: {
    downloadCsv() {
      const filename = `${this.campaign?.title}_応募者のフォロワー分析`
      const data: (string | number)[][] = []
      const header = ['ラベル', '値', '割合']

      data.push(header)
      const totalData = this.followerAnalytics
        .map(follower => follower.count)
        .reduce((count, current) => count + current, 0)

      this.followerAnalytics.forEach(follower => {
        const percentage = !totalData ? 0 : Math.round((follower.count / totalData) * Math.pow(100, 2)) / 100
        data.push([follower.label, follower.count, percentage])
      })

      return { filename, data }
    }
  }
})
</script>
